import { render, staticRenderFns } from "./DisplayTotal.vue?vue&type=template&id=1e0e658f&"
import script from "./DisplayTotal.vue?vue&type=script&lang=ts&"
export * from "./DisplayTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0e658f')) {
      api.createRecord('1e0e658f', component.options)
    } else {
      api.reload('1e0e658f', component.options)
    }
    module.hot.accept("./DisplayTotal.vue?vue&type=template&id=1e0e658f&", function () {
      api.rerender('1e0e658f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/DisplayTotal.vue"
export default component.exports